import React from 'react';
import { Button, Select, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchRelationshipSearch, fetchRelationshipSearchData, } from '../../appRedux/actions/Common';
import { createDebounce } from '../../util/methods';

class RelationshipSearchFilter extends React.Component {
  state = {
    value: []
  };

  componentDidMount() {
  }

  componentWillReceiveProps(nextProps) {
  }

  debouncedSearch = createDebounce((value) => {
    console.log('Rel Searching for:', value);
    const { data } = this.props;
    this.props.fetchRelationshipSearchData(value, data.options.ref, data.options.main || 'name');
  }, 400); // Adjust the delay (in milliseconds) as needed

  handleSearch = value => {
    this.debouncedSearch(value);
  };

  handleChange = value => {
    this.setState({ value });
    this.props.setSelectedKeys(value ? [value] : []);

    setTimeout(() => {
      this.props.fetchRelationshipSearch();
    }, 200);
  };

  searchClicked = (selectedKeys, confirm, data) => {
    this.setState({ value: [] });
    this.props.handleFilter(selectedKeys, confirm, data);
  }

  resetClicked = (clearFilters, data) => {
    this.setState({ value: [] });
    this.props.handleReset(clearFilters, data);
  }

  render() {
    const { setSelectedKeys, handleFilter, selectedKeys, confirm, data, clearFilters, handleReset, searchData } = this.props;

    return (
      <div style={{ padding: 8 }}>
        <Select
          showSearch
          mode='multiple'
          value={this.state.value}
          placeholder={''}
          defaultActiveFirstOption={false}
          showArrow={false}
          filterOption={false}
          onSearch={this.handleSearch}
          onChange={this.handleChange}
          notFoundContent={null}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        >
          {searchData && searchData.length && searchData.map(item => {
            return <Select.Option key={item._id} value={item._id}><Tooltip
              title={item[data.options.main || 'name']}>{item[data.options.main || 'name']}</Tooltip></Select.Option>
          })}
        </Select>
        <Button
          type="primary"
          onClick={() => this.searchClicked(selectedKeys, confirm, data)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => this.resetClicked(clearFilters, data)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    );
  }
}

RelationshipSearchFilter.defaultProps = {};

RelationshipSearchFilter.propTypes = {
  data: PropTypes.object,
  handleFilter: PropTypes.func,
  handleReset: PropTypes.func,
  setSelectedKeys: PropTypes.func,
  selectedKeys: PropTypes.array,
  confirm: PropTypes.func,
  clearFilters: PropTypes.func,
  fetchRelationshipSearch: PropTypes.func,
  fetchRelationshipSearchData: PropTypes.func,
};


const mapStateToProps = ({ commonData, assetService }) => {
  return {
    filters: commonData.filters,
    modules: commonData.modules,
    searchData: commonData.relationshipSearch
  };
};

function mapDispatchToProps(dispatch) {
  return {
    fetchRelationshipSearch,
    fetchRelationshipSearchData
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(RelationshipSearchFilter);
